const baseURL = process.env.REACT_APP_BASE_URL;

export async function fetchLegislationTitleSuggestions(text) {

    const token = localStorage.getItem("token") || "";
    const axios = (await import("axios")).default;

    const url = `${baseURL}/quick-search/search-completion-statute-titles?size=550`;

    try {
        const response = await axios.post(
            url,
            {
                search_text: text,
            },
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response.data || [];
    } catch (error) {
        console.error("Error fetching statute titles:", error);
        return [];
    }
}

export const fetchLegislationProvisionSuggestions = async (queryTwo, legislationTitle) => {

    const token = localStorage.getItem("token") || "";
    const axios = (await import("axios")).default;

    const payload = {
        selected_title: legislationTitle,
        prefix: queryTwo
    }

    try {
        const response = await axios.post(
            `${baseURL}/quick-search/search-completion-statute-sections?size=500`,
            payload,
            {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            }
        );

        return response.data || [];
    } catch (error) {
        console.error('Error fetching statute sections:', error);
        return [];
    }
};